import { search_asp, trimFieldString } from "../util";
import { min, max } from "d3";

export function translateConvertAxisLabelToLegend(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(convert_axis_label_to_legend,L,T,CH,F)
  let field = trimFieldString(args[3]);
  let channel = args[2];
  let font_size_reduce = search_asp(parsed, "do(reduce_text_size," + args[1] + ").")[0], fontSize;
  if (font_size_reduce) {
    let text_map = mapping[args[1]];
    let layer = source.layer?.[text_map?.layer];
    let text = layer?.text[text_map?.text];
    let scale_factor;
    search_asp(parsed, "do(disproportionate_resizing", "startsWith").forEach((p) => {
      scale_factor = source.layout.width / parseFloat(p.args[1]);
    });
    search_asp(parsed, "do(proportionate_resizing", "startsWith").forEach((p) => {
      scale_factor = source.layout.width / parseFloat(p.args[1]);
    });
    if (text?.items) {
      fontSize = text.items?.map((item, index) => { return { index, fontSize: Math.max((item.fontSize || 16) / scale_factor, 12) } });
    }
  }
  rules.push({
    category: "recommender",
    description: `Convert axis label to legend for ${field}`,
    specifier: {
      role: "axis",
      field: field
    },
    action: "replace",
    option: {
      to: {
        role: "legend",
        channel: channel,
        orient: "top",
        direction: "horizontal",
        margin: 30,
        padding: null,
        ignoreVLpos: true,
        title: true,
        items: fontSize
      }
    }
  });
  return rules;
}

export function translateConvertLegendToAxisLabel(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(convert_legend_to_axis_label,L,T,CH,F)
  let field = trimFieldString(args[3]);
  let channel = args[2];
  rules.push({
    category: "recommender",
    description: `Convert legend to axis for ${field}`,
    specifier: {
      role: "legend",
      channel: channel,
      field: field
    },
    action: "replace",
    option: {
      to: {
        role: "axis",
        width: null
      }
    }
  });
  return rules;
}


export function translateConvertMarkLabelToAxisLabel(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(convert_mark_label_to_axis_label,L,T,F)
  let field = trimFieldString(args[2]);
  let layer_index = parseInt(mapping[args[0]]?.layer), layer = source.layer?.[layer_index];
  let text_index = parseInt(mapping[args[1]]?.text), text = layer.text?.[text_index];
  let rule = {
    category: "recommender",
    description: `Convert mark label to axis label for ${field}`,
    specifier: {
      role: "mark.label",
      field
    },
    action: "replace",
    option: {
      to: {
        role: "axis.label",
        width: 160,
        orient: null,
        offset: 10,
        dx: null,
        dy: null
      }
    }
  };
  let is_for_tiny = search_asp(parsed, "detect(for_tiny)")?.length > 0
  let has_serial = search_asp(parsed, "do(serialize_axis_label,", "startsWith")[0];
  let is_serial = has_serial?.args?.[1] === args[0] && has_serial?.args?.[2] === args[1] && has_serial?.args?.[3] === args[2]
  if (is_for_tiny && !is_serial) {
    rule.option.to.width = 80;
  } else if (is_serial) {
    rule.option.to.width = null;
  }
  if (layer.name) rule.specifier.layer = { id: layer.name };
  else rule.specifier.layer = { index: layer_index };
  if (text.name) rule.specifier.id = text.name;
  else rule.specifier.index = text_index;
  rules.push(rule);

  if (is_for_tiny) {
    let rule_adj = {
      category: "recommender",
      description: `Modify axis labels for ${field} (line height)`,
      specifier: {
        role: "axis.label",
        field
      },
      action: "modify",
      option: {
        dy: "-50%",
        items: text.items?.map((d, i) => { return { index: i, lineHeight: 80 } }) || [{ index: 0, lineHeight: 80 }]
      }
    };
    // debug here
    if (is_serial) {
      rule_adj.option.serial = true;
      rule_adj.option.dy = null;
    }
    rules.push(rule_adj);
    if (is_serial) {
      let rule_adj2 = {
        category: "recommender",
        description: `Modify horizontal axis (offset)`,
        specifier: {
          role: "hAxis"
        },
        action: "modify",
        option: {
          offset: 10
        }
      };
      rules.push(rule_adj2);
      let rule_adj3 = {
        category: "recommender",
        description: `Modify axis grids`,
        specifier: {
          role: "axis"
        },
        action: "modify",
        option: {
          grid: null
        }
      };
      rules.push(rule_adj3);
    }
  }
  return rules;
}
export function translateConvertMarkLabelToLegend(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(convert_mark_label_to_legend,l0,t2,\"category\",stroke). 
  let field = trimFieldString(args[2]);
  let layer_index = parseInt(mapping[args[0]]?.layer), layer = source.layer?.[layer_index];
  let text_index = parseInt(mapping[args[1]]?.text), text = layer.text?.[text_index];
  let channel = args[3];
  let rule = {
    category: "recommender",
    description: `Convert mark label to legendfor ${field}`,
    specifier: {
      role: "mark.label",
      field
    },
    action: "replace",
    option: {
      to: {
        role: "legend",
        channel,
        orient: "top",
        offset: 50
      }
    }
  };
  if (layer.name) rule.specifier.layer = { id: layer.name };
  else rule.specifier.layer = { index: layer_index };
  if (text.name) rule.specifier.id = text.name;
  else rule.specifier.index = text_index;
  rules.push(rule);
  return rules;
}

export function translateRepositionLegend(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(reposition_legend,T,top).
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let direction = args[1];
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Reposition legend for ${text.field}`,
      specifier: {
        role: "legend",
        field: text.field
      },
      action: "reposition",
      optoin: {
        "orient": direction
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateAddLegend(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_legend,L,F,C). 
  let layer = source.layer?.[mapping[args[0]]?.layer];
  let field = trimFieldString(args[1]);
  let channel = args[2];
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add legend for ${field}`,
      specifier: {
        role: "layer"
      },
      action: "add",
      option: {
        role: "text",
        text: {
          type: "legend",
          field,
          channel,
          items: [{ fontSize: 12 }]
        }
      }
    }
    if (layer.name) rule.specifier.id = layer.name;
    else rule.specifier.index = mapping[args[0]]?.layer;
    if (search_asp(parsed, "do(make_heatmap", "startsWith")?.length > 0) {
      rule.option.text.orient = "top";
    }
    rule.option.text.title = {
      value: field,
      marginBottom: 5,
      fontSize: 14
    }
    rules.push(rule);
  }
  return rules;
}

export function translateRemoveAxisGrid(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_axis_grid,haxis,for_tiny). 
  let rules = [];
  let axis = { haxis: "hAxis", vaxis: "vAxis" }[args[0]]
  if (axis && source.layout?.[axis]) {
    let rule = {
      category: "recommender",
      description: `Remove the ${{ hAxis: "horizontal ", vAxis: "vertical " }[axis] || ""}axis grid`,
      specifier: {
        role: axis + ".grid"
      },
      action: "remove"
    };
    rules.push(rule);
  }
  return rules;
}